const ExploreNearData25 = [
  {
    title: "Wishing Tree",
    description: `Make a wish and tie it to the hotel’s enchanting Wishing Tree. Everything you need is provided–just bring your hopes and wishes!`,
    distance: 0,
  },
  {
    title: "Apiary (Bee Garden)",
    description: `Visit the resort’s working bee garden and learn how honey is harvested on-site. You can even purchase the hotel’s own honey and other sweet products from the Trading Post Café.`,
    distance: 0,
  },
  {
    title: "Butterfly Sanctuary Garden",
    description: `Stroll through a native garden built to attract endangered monarch butterflies. Look for handcrafted butterfly “hotels” designed to encourage their return to the area.`,
    distance: 0,
  },
  {
    title: "Botanical Garden & Self-Guided Trail",
    description: `Explore 9.5 acres of lush grounds on a self-guided garden tour. Just scan the QR codes to learn about nearly 200 types of plants and flowers.`,
    distance: 0,
  },
  {
    title: "Wellness Activities",
    description: `Enjoy weekend yoga and sound baths on the property.
    <ul>
    <li>Mats and towels are provided.</li>
    <li>Check the front desk for the daily schedule and location.</li>
    </ul>`,
    distance: 0,
  },
  {
    title: "Salk Institute for Biological Studies",
    description: `Architecture lovers and science fans will appreciate this serene, globally renowned research campus. It is just a short walk from the resort.`,
    distance: 0.1,
    url: "https://www.salk.edu/",
  },
  {
    title: "Black’s Beach",
    description: `This clothing-optional beach features scenic cliffs and strong waves.
    <ul>
    <li>Accessible by foot only via a steep path with stairs.</li>
    <li>Best for surfers or adventurous beachgoers.</li>
    </ul>`,
    distance: 1,
    url: "https://www.sandiego.gov/lifeguards/beaches/blacks",
  },
  {
    title: "Torrey Pines Gliderport",
    description: `Watch paragliders launch from coastal cliffs or take a tandem flight yourself. It also offers access to Black’s Beach below the cliffs.`,
    distance: 0.6,
    url: "https://www.flytorrey.com/",
  },
  {
    title: "E-Bike Rentals",
    description: `Every hotel guest receives one hour of free e-bike use per day. Available on a first-come, first-served basis.`,
    distance: 0,
  },
  {
    title: "Walking Trails",
    description: `Pick up maps at the concierge for these nearby trails:<ul>
      <li>Gliderport Trail (0.6 miles / 170-ft elevation): Quick but steep with panoramic ocean views</li>
      <li>Snake Path (560 ft): A serpent-shaped art path leading to UCSD’s Geisel Library</li>
      <li>Guy Fleming Trail (0.8 miles / 52-ft elevation): A gentle loop with wildflowers and cliff views</li>
      <li>Razor Point Trail (1.3 miles / 150-ft elevation): Scenic, photo-friendly trail great for light hiking or running</li>
      <li>Broken Hill Trail (2.3 miles / 324-ft elevation): A longer hike with beach access and regional plant life</li>
      <li>Tide Pools Walk (3.9 miles / 285-ft elevation): Explore sea life and wildflowers during low tide</li>
    </ul>`,
    distance: 0,
  },
  {
    title: "Swimming Pool",
    description: `Relax between sessions in the hotel’s heated saltwater pool and whirlpool.`,
    distance: 0,
  },
  {
    title: "Spa",
    description: `Treat yourself to massages or facials at the on-site spa. Advance booking is required.`,
    distance: 0,
  },
  {
    title: "Live Music at Estancia",
    description: `Enjoy nightly entertainment from local performers right on the property.`,
    url: `https://www.acousticspottalent.com/venues/estancia-la-jolla`,
    distance: 0,
  },
  {
    title: "Fitness Center",
    description: `Work out in the executive fitness center featuring treadmills, elliptical machines, Peloton bikes, and free weights.`,
    distance: 0,
  },
  {
    title: "Pet-Friendly Perks",
    description: `Bringing a dog? Estancia offers pet accommodations, a room service menu just for pups, a “Fetch” box filled with complimentary sticks, and more.`,
    distance: 0,
  },
];

export default ExploreNearData25;
